import React, { Component } from 'react'
import { Modal, Button, Col, Row, Spin, message } from 'hljd'
import SortUpload from '../SortUpload'
import styles from './style.module.less'

export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      uploading: false,
      areaHeight: 350
    }
    this.state.imgList = this.props?.initValue || []
  }

  setSpin(state) {
    this.setState({
      uploading: state
    })
  }

  setImgList(data) {
    if (Array.isArray(data)) {
      this.setState({
        imgList: data
      })
    }
  }

  componentDidMount() {
    const ch = document.documentElement.clientHeight
    const remain = ch - 417
    this.setState({
      areaHeight: remain > 350 ? remain : 350
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({
        imgList: this.props?.initValue || []
      })
    }
  }

  render() {
    const {
      title = '上传图片',
      width = 994,
      visible = false,
      min,
      max = 50,
      maxSize = 10,
      maxHeight = 8192,
      maxWidth,
      onSave,
      clearHistory,
      onCancel
    } = this.props

    const { imgList, areaHeight } = this.state
    const remain = max - imgList.length
    const initSortUploadParams = {
      max,
      maxSize,
      maxHeight,
      maxWidth
    }

    const saveHandler = () => {
      if (min && imgList.length < min) {
        message.error({
          content: `上传图片不得小于${min}张，请继续选择`,
          key: 'picNum'
        })
      } else {
        onSave(imgList)
        if (clearHistory) {
          this.setState({
            imgList: []
          })
        }
      }
    }

    const cancelHandler = () => {
      onCancel(imgList)
      if (clearHistory) {
        this.setState({
          imgList: []
        })
      }
    }

    const limitText =
      '2. 支持JPG、PNG和BMP等大部分格式，图片' +
      (maxWidth ? `宽度在${maxWidth}像素以下，` : '') +
      (maxHeight ? `高度在${maxHeight}像素以下，` : '') +
      `图片大小不可大于${maxSize}M；`

    return (
      <Modal
        title={title}
        width={width}
        visible={visible}
        onCancel={cancelHandler}
        footer={
          <Row>
            <Col flex="auto" style={{ textAlign: 'left' }}>
              <span style={{ lineHeight: '32px' }}>
                还可以上传{remain}张图片，你可以拖拽调整图片位置
              </span>
            </Col>
            <Col>
              <Button type="default" onClick={cancelHandler}>
                取消
              </Button>
              <Button
                type="primary"
                onClick={saveHandler}
                disabled={this.state.uploading}
              >
                保存
              </Button>
            </Col>
          </Row>
        }
      >
        <Spin delay={300} spinning={this.state.uploading} tip="图片正在上传...">
          <div className={styles.info}>
            <p>1. 请勿在图片添加任何文字、水印、logo，以免审核不通过；</p>
            <p>
              <span>{limitText}</span>
            </p>
            <p>3. 支持多张图片同时上传，支持在本弹框拖拽调整顺序。</p>
          </div>
          <div className={styles.ctrlPanel} style={{ height: areaHeight }}>
            <SortUpload
              value={imgList}
              onChange={list => this.setImgList(list)}
              onLoad={e => this.setSpin(!e)}
              {...initSortUploadParams}
            />
          </div>
        </Spin>
      </Modal>
    )
  }
}
